export function formatCurrency(amount: number, simplify = true) {
  const hasCentsValue = amount % 1 !== 0;
  return Intl.NumberFormat('fi', {
    style: 'currency',
    currency: 'EUR',
    // Display 240.00 as "240 €" by default
    maximumFractionDigits: simplify && !hasCentsValue ? 0 : 2,
  }).format(amount);
}
